// extracted by mini-css-extract-plugin
module.exports = {"editorFontStack":"richTextEditor-module--editorFontStack--3H4YI"};